import routerOptions0 from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}